/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AssignTermUseModalAliases {
  FETCH_HPMS_TERM_USE = 'fetch-hpms-term-use',
  HPMS_TERM_SERVICE = 'hpms-term-service',
  MODAL_ASSIGN_TERM_USE = 'modal-assign-term-use',
  PANEL_0 = 'panel-0',
}
export { AssignTermUseModalAliases };
